import React from "react";
import { Dropdown, DropdownItemProps, DropdownProps } from "@fluentui/react-northstar";
import { Page } from "powerbi-client";
import styles from "../PowerBiReportsTab.module.scss";
import pl from "../../shared/messages/pl";

export interface PowerBiReportPagesDropdownProps {
    selectedPage?: Page;
    availablePages: Page[];
    loading: boolean;
    onPageSelected: (page: Page) => void;
}

export const PowerBiReportPagesDropdown: React.FC<PowerBiReportPagesDropdownProps> = (props) => {
    const value: DropdownItemProps = {
        header: props.selectedPage?.displayName,
    };

    const items = props.availablePages.map(
        (page): DropdownItemProps => ({
            header: page.displayName,
            selected: page.displayName === props.selectedPage?.displayName,
        })
    );

    const onChange = (_: React.MouseEvent | React.KeyboardEvent | null, data: DropdownProps) => {
        const page = props.availablePages.find(
            (page) => page.displayName === (data.value as DropdownItemProps)?.header
        );
        if (page) {
            props.onPageSelected(page);
        }
    };

    return (
        <Dropdown
            checkable
            inverted
            value={props.loading ? undefined : value}
            items={items}
            onChange={onChange}
            placeholder={pl.powerBiReports.loadingReportPages}
            disabled={props.loading}
            className={styles.reportDropdown}
            fluid
        />
    );
};
